import { formatNumberToDk } from '.';

export function formatBytes(bytes: number, decimals = 2) {
  if (bytes === 0) {
    return '0 Bytes';
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${formatNumberToDk(parseFloat((bytes / k ** i).toFixed(dm)), dm)} ${sizes[i]}`;
}

export function formatBytesWithBlank(bytes: number, decimals = 2) {
  if (bytes === 0) {
    return '';
  }

  return formatBytes(bytes, decimals);
}
